import OrderBasket from './OrderBasket';

export default {
  OrderBasket,
};
